<template>
  <el-dialog
    v-if="visible"
    show-close
    v-el-dialog-drag
    custom-class="feedback-dialog"
    width="900px"
    title="客服反馈"
    visible
    :close-on-click-modal="false"
    @close="close"
  >
    <feedback-form ref="editForm" :params="params" />
  </el-dialog>
</template>
<script>
import FeedbackForm from './index'
export default {
  components: {
    FeedbackForm,
  },
  props: {
    visible: Boolean,
    code: String,
    params: {
      type: Object,
      default: () => {},
    },
  },

  watch: {
    params: {
      handler(params) {
        this.formData = params
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
  overflow: hidden !important;
}
</style>

<style lang="scss">
.feedback-dialog {
  position: absolute !important;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: 0 auto !important;
  margin-top: 0 !important;
}
</style>
